import { useQuery } from "@tanstack/react-query"
import { campaignLaunchAudienceQuery } from "../lib/campaignLaunchAudienceQuery"

export function useCampaignLaunchAudienceQuery(
  ...args: Parameters<typeof campaignLaunchAudienceQuery>
) {
  return useQuery(campaignLaunchAudienceQuery(...args))
}
